// TODO: remove TypeOfLoan in the future
export enum StepKey {
  // Refinance & Common Steps
  TypeOfLoan = 'TypeOfLoan',
  VaEligibility = 'VaEligibility',
  LoanPurpose = 'LoanPurpose',
  PropertyType = 'PropertyType',
  PropertyUsageDetails = 'PropertyUsageDetails',
  PropertyAddress = 'PropertyAddress',
  PropertyValue = 'PropertyValue',
  PurposeOfRefinance = 'PurposeOfRefinance',
  FirstTimeHomeBuyer = 'FirstTimeHomeBuyer',
  CurrentMortgageBalance = 'CurrentMortgageBalance',
  CurrentCreditProfile = 'CurrentCreditProfile',
  PersonalInfo = 'PersonalInfo',
  RateComparison = 'RateComparison',
  FullPersonalInfo = 'FullPersonalInfo',
  LodeStarQuestions = 'LodeStarQuestions',
  CreditProfile = 'CreditProfile',
  PropertyInformation = 'PropertyInformation',
  TitleHolder = 'TitleHolder',
  ResidenceInfo = 'ResidenceInfo',
  Reo = 'Reo',
  Income = 'Income',
  Assets = 'Assets',
  Declarations = 'Declarations',
  PropertyAndLoan = 'PropertyAndLoan',
  YourFinances = 'YourFinances',
  MilitaryServices = 'MilitaryServices',
  HomeownershipEducationAndHousingCounseling = 'HomeownershipEducationAndHousingCounseling',
  LanguagePreferences = 'LanguagePreferences',
  DemographicInformation = 'DemographicInformation',
  Review = 'QuickReview',
  CashOutAmount = 'CashOutAmount',
  FinalRateComparison = 'FinalRateComparison',
  DeclarationsGeneral = 'DeclarationsGeneral',
  AdditionalQuestions = 'AdditionalQuestions',

  // Purchase Steps
  PurchaseProcessType = 'PurchaseProcessType',
  PurchasePrice = 'PurchasePrice',
  DownPayment = 'DownPayment',
  DownPaymentSource = 'DownPaymentSource',
  PurchaseLocation = 'PurchaseLocation',
  Budget = 'Budget',
  WorkingWithRealtor = 'WorkingWithRealtor',
  RealtorInLoop = 'RealtorInLoop',
  RealtorInfo = 'RealtorInfo',

  // Additional Loan Steps
  AdditionalLoanCurrentMortgageBalance = 'AdditionalLoanCurrentMortgageBalance',
  AdditionalLoanSecondMortgageType = 'AdditionalLoanSecondMortgageType',
  AdditionalLoanHelocHighBalance = 'AdditionalLoanHelocHighBalance',
  AdditionalLoanSecondMortgageLoanAmount = 'AdditionalLoanSecondMortgageLoanAmount',
  AdditionalLoanHelocExistingMortgage = 'AdditionalLoanHelocExistingMortgage',
  AdditionalLoanHomeEquityCreditPurpose = 'AdditionalLoanHomeEquityCreditPurpose',

  // Unsecured Loan Steps
  UnsecuredLoanAmount = 'UnsecuredLoanAmount',
  UnsecuredLoanPurpose = 'UnsecuredLoanPurpose',

  // Chattel Loan Steps
  ChattelPurposeType = 'ChattelPurposeType',
  ChattelLoanAmount = 'ChattelLoanAmount',
  ChattelHomeCondition = 'ChattelHomeCondition',
  ChattelManufacturedHomeDetails = 'ChattelManufacturedHomeDetails',
  ChattelParkCommunityInfo = 'ChattelParkCommunityInfo',
  ChattelEConsent = 'ChattelEConsent',
}
